<app-tutor-menu>
  <nb-card>
    <nb-card-header>
      <h4>{{ 'pages.tutors.access.title' | translate }}</h4>
      <p class="hint">{{ 'pages.tutors.access.hint' | translate }}</p>
    </nb-card-header>
    <nb-card-body>
      <div class="access">
        <app-search-input
          class="access__search"
          [(value)]="search"
          (valueChange)="onSearchChange()"
        ></app-search-input>

        <div *ngIf="loading" class="access__loading">
          <nb-spinner status="primary"></nb-spinner>
        </div>

        <ng-container *ngIf="!loading">
          <ul class="access__list">
            <li *ngFor="let row of pagedRows" class="access__row">
              <div class="access__user">
                <span class="access__name">{{ row.user.name || row.user.email }}</span>
                <span class="access__email" *ngIf="row.user.name">{{ row.user.email }}</span>
              </div>

              <div class="access__badges">
                <span class="access__badge access__badge--owner" *ngIf="row.isOwner">{{
                  'pages.tutors.access.ownerBadge' | translate
                }}</span>
                <span
                  class="access__badge access__badge--creator"
                  *ngIf="row.isCreator && !row.isOwner"
                  >{{ 'pages.tutors.access.creatorBadge' | translate }}</span
                >
              </div>

              <nb-toggle
                [checked]="row.hasAccess"
                [disabled]="row.isOwner || row.busy"
                (checkedChange)="toggle(row)"
                [title]="
                  row.isOwner ? ('pages.tutors.access.ownerLocked' | translate) : ''
                "
              ></nb-toggle>
            </li>
          </ul>

          <p *ngIf="!filteredRows.length" class="access__empty">
            {{ 'pages.tutors.access.empty' | translate }}
          </p>

          <app-pagination
            *ngIf="filteredRows.length > pageSize"
            class="access__pagination"
            [totalItems]="filteredRows.length"
            [itemsPerPage]="pageSize"
            [currentPage]="page"
            [pageSizeOptions]="pageSizeOptions"
            (pageChanged)="onPageChange($event)"
            (itemsPerPageChange)="onPageSizeChange($event)"
          ></app-pagination>
        </ng-container>
      </div>
    </nb-card-body>
  </nb-card>
</app-tutor-menu>
